'use client'

import { Status } from 'my-purchases/components/Card/components/Status/Status'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'
import type { OrderStatusDetail } from 'my-purchases/types/purchaseStatus'
import { getOrderStatusInfo } from 'my-purchases/utils/getOrderStatusInfo'

import styles from './OrderStatusTitle.module.scss'

interface OrderStatusTitleProps {
	readonly order: OrderDetails | OrderStatusDetail
}

export function OrderStatusTitle({ order }: OrderStatusTitleProps) {
	const { active } = order ?? {}

	const paymentMethod =
		'paymentMethod' in order ? order.paymentMethod : undefined

	const status =
		getOrderStatusInfo({
			order,
			paymentMethod,
			showDescription: true,
			isActive: active,
		}) ?? {}

	return (
		<div className={styles.title}>
			<Status status={status} className={styles.status} />
		</div>
	)
}
